import { Box, Container, Paper, Stack } from '@mui/material';
import React from 'react';
import { IdeaRoomLogo } from './IdeaRoomLogo';

export const SignInPage: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Container sx={{ height: '100%', maxWidth: '100% !important', backgroundColor: '#F2F4F5' }}>
    <Paper
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        textAlign: 'center',
        transform: 'translate(-50%, -50%)',
        width: '375px',
        padding: '24px',
        border: '1px solid #DEDEDE',
        borderRadius: '8px',
      }}
      elevation={0}
    >
      <Stack spacing="24px">
        <Box>
          <IdeaRoomLogo height="100px" />
        </Box>
        {children}
      </Stack>
    </Paper>
  </Container>
);
